import axios from "axios";
import Cookies from "js-cookie";
import { handleUnauthorized } from "../utils/auth.utils";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    // Read CSRF token fresh on every request to handle token rotation
    const csrfToken = Cookies.get("csrftoken");
    if (csrfToken) {
      config.headers["X-CSRFToken"] = csrfToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // On 401, re-validate the session once before logging out (fire-and-forget so
    // the original request still rejects immediately). handleUnauthorized skips
    // auth endpoints and only clears the session if the token is truly invalid.
    if (error.response?.status === 401) {
      void handleUnauthorized(error.config?.url || "", {
        method: error.config?.method,
        source: "axios",
      });
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
